export const defaultOrdersCount = {
  total: 0,
  buy: 0,
  sell: 0,
};
